class Gapi {
    constructor() {
        this.clientId =
            "523706595204-o06e86vk7ufrvbc2hia3thue5968rr5n.apps.googleusercontent.com";

        window.g = this;
    }

    async ensureLoaded() {
        if (this.loaded) {
            return this.loaded;
        }

        this.loaded = new Promise((resolve, reject) => {
            const loadTimeout = setTimeout(() => {
                this.loaded = null;
                reject("GAPI load timeout");
            }, 10000);

            const url = "https://apis.google.com/js/api.js";
            const doc = window.document;
            const body = doc.getElementsByTagName("body")[0];

            const script = doc.createElement("script");
            script.src = url;
            script.addEventListener(
                "load",
                () => {
                    clearTimeout(loadTimeout);
                    this.gapi = window.gapi;
                    this.init().then(resolve, () => {
                        this.loaded = null;
                        reject("GAPI init failed");
                    });
                },
                false,
            );
            body.appendChild(script);
        });
        return this.loaded;
    }

    init = async () => {
        await new Promise(resolve => {
            this.gapi.load("client:auth2", resolve);
        });

        const result = await window.gapi.client.init({
            discoveryDocs: [
                "https://sheets.googleapis.com/$discovery/rest?version=v4",
            ],
            clientId: this.clientId,
            scope: "https://www.googleapis.com/auth/spreadsheets",
        });

        this.gapi.auth2
            .getAuthInstance()
            .isSignedIn.listen(this.notifySignedin);
        return result;
    };

    notifySignedin = () => {
        if (this.signedInChanged) {
            const signedIn = this.gapi.auth2.getAuthInstance().isSignedIn.get();
            this.signedInChanged(signedIn);
        }
    };

    test() {
        this.ensureLoaded();
    }

    listenSignin(cb) {
        this.signedInChanged = cb;
        this.ensureLoaded().then(this.notifySignedin);
    }

    append(values) {
        return this.ensureLoaded().then(() => {
            return this.gapi.client.sheets.spreadsheets.values.append(values);
        });
    }

    batchGet(values) {
        return this.ensureLoaded().then(() => {
            return this.gapi.client.sheets.spreadsheets.values.batchGet(values);
        });
    }

    signIn() {
        return this.ensureLoaded().then(() => {
            return this.gapi.auth2.getAuthInstance().signIn();
        });
    }
}

export default Gapi;



// WEBPACK FOOTER //
// ./src/Gapi.js